import EmailSender from "./EmailSender";

export default EmailSender;
